module.exports = __webpack_public_path__ + "img/check.4cbab1e6.png";